/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Cancel_Estes_Pickup_TitleInputs */

const en_orders_cancel_estes_pickup_title = /** @type {(inputs: Orders_Cancel_Estes_Pickup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel ESTES Pickup?`)
};

const es_orders_cancel_estes_pickup_title = /** @type {(inputs: Orders_Cancel_Estes_Pickup_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar recoleccion ESTES?`)
};

/**
* | output |
* | --- |
* | "Cancel ESTES Pickup?" |
*
* @param {Orders_Cancel_Estes_Pickup_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_cancel_estes_pickup_title = /** @type {((inputs?: Orders_Cancel_Estes_Pickup_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Cancel_Estes_Pickup_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_cancel_estes_pickup_title(inputs)
	return es_orders_cancel_estes_pickup_title(inputs)
});